export const COIN = "HUSD";
export const GT = "HATCHI";
export const LP = "LEET LP";
// export const LP = "ETH/LUSD LP";
